export default function stringFormatFilter (input, ...args) {
  return input.replace(/\{(\d+)\}/g, function (match, capture) {
    return args[capture]
  })
}

export function formatWithDictionary (input, dictionary) {
  return input.replace(/\{([^}]+)\}/g, function (match, capture) {
    return dictionary[capture] || `{${capture}}`
  })
}
